// DOCS: https://schema.org/BreadcrumbList
const getSchemaObj = items => {
  const itemListElement = []

  items.map((item, index) => {
    const newItemElement = {
      '@type': 'ListItem',
      position: index,
      item: {
        '@id': item.url,
        name: item.content,
      },
    }

    itemListElement.push(newItemElement)
  })

  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  }

  return baseSchema
}

export default {
  getSchemaObj,
}
